import { getFullName } from "@/utils/users";

export const fullNameFilter = user => {
  return getFullName(user);
};
